import React, { useState, useEffect, useRef } from 'react';
import { GMap } from 'primereact/gmap';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { loadGoogleMapsEmpleado } from '../DatosEmpleado/GoogleMapsEmpleado';

const DibujadorDeCerca = ({ cercaInicial = '[]', onConfirmar, onCancelar, soloConsulta = false, datZona = {} }) => {
    const [mapReady, setMapReady] = useState(false);
    const [puntos, setPuntos] = useState([]);
    const [overlays, setOverlays] = useState([]);
    const [currentCenter, setCurrentCenter] = useState({ lat: -0.180653, lng: -78.467834 });

    const inputSearchRef = useRef(null);
    const [searchQuery, setSearchQuery] = useState('');

    const toast = useRef(null);
    const polygonRef = useRef(null); // Referencia para el objeto Google Maps

    const [nombre, setNombre] = useState('');

    // --- CARGAR DATOS INICIALES ---
    useEffect(() => {
        if (typeof loadGoogleMapsEmpleado === 'function') {
            loadGoogleMapsEmpleado(() => {
                setMapReady(true);
                try {
                    if (cercaInicial && cercaInicial.trim().length > 0) {
                        //if (cercaInicial && cercaInicial.length > 0) {
                        const puntosParseados = JSON.parse(cercaInicial);
                        if (Array.isArray(puntosParseados) && puntosParseados.length > 0) {
                            setPuntos(puntosParseados);
                            setCurrentCenter(puntosParseados[0]);
                            setTimeout(() => actualizarVisuales(puntosParseados), 100);
                        }
                    }
                } catch (e) {
                    console.error('Error cargando cerca inicial', e);
                }
                // INICIALIZAR BUSCADOR
                setTimeout(() => {
                    const inputElement = inputSearchRef.current?.getElement?.() || inputSearchRef.current;

                    if (inputElement && window.google?.maps?.places) {
                        const autocomplete = new window.google.maps.places.Autocomplete(inputElement, {
                            fields: ['geometry', 'formatted_address'],
                            types: ['geocode', 'establishment']
                        });

                        autocomplete.addListener('place_changed', () => {
                            const place = autocomplete.getPlace();
                            if (place.geometry && place.geometry.location) {
                                const newPos = {
                                    lat: place.geometry.location.lat(),
                                    lng: place.geometry.location.lng()
                                };

                                actualizarMarcador(newPos, true);

                                setSearchQuery(place.formatted_address);
                            }
                        });

                        // Evitar que el 'Enter' refresque la página
                        window.google.maps.event.addDomListener(inputElement, 'keydown', (e) => {
                            if (e.keyCode === 13) e.preventDefault();
                        });
                    }
                }, 600);
            });
        }
    }, [cercaInicial]);

    const actualizarMarcador = (position, moveMap = true) => {
        if (!window.google) return;

        // 1. Si quieres un marcador visual de la búsqueda (opcional)
        const buscadorMarker = new window.google.maps.Marker({
            position: position,
            title: 'Lugar encontrado',
            icon: {
                url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png' // Color diferente para no confundir
            }
        });

        // 2. Agregamos el marcador a los overlays SIN borrar los anteriores (la cerca)
        // Usamos el callback del set para mantener lo que ya existe
        setOverlays((prev) => {
            // Filtramos para eliminar marcadores de búsquedas anteriores si existen
            // pero manteniendo los Polígonos
            const otrosOverlays = prev.filter((ov) => !(ov instanceof window.google.maps.Marker));
            return [...otrosOverlays, buscadorMarker];
        });

        // 3. Movemos la cámara al lugar encontrado
        if (moveMap) {
            setCurrentCenter(position);
        }
    };

    const actualizarVisuales = (nuevaLista) => {
        if (!window.google || !nuevaLista) return;

        const nuevosOverlays = [];

        // --- DIBUJAR EL POLÍGONO (LA CERCA) ---
        if (nuevaLista.length > 0) {
            const nuevoPoligono = new window.google.maps.Polygon({
                paths: nuevaLista,
                strokeColor: '#FF5722',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: '#FF5722',
                fillOpacity: 0.35,
                editable: true, // Permite mover los puntos individualmente
                draggable: true // Permite mover toda la forma
            });

            polygonRef.current = nuevoPoligono;
            nuevosOverlays.push(nuevoPoligono);

            // Escuchar cambios manuales del usuario (arrastrar vértices)
            ['insert_at', 'remove_at', 'set_at'].forEach((evento) => {
                window.google.maps.event.addListener(nuevoPoligono.getPath(), evento, () => {
                    obtenerPuntosActualizados(nuevoPoligono);
                });
            });
        }

        setOverlays([...nuevosOverlays]);
    };

    // Extrae las coordenadas actuales del polígono después de ser editado
    const obtenerPuntosActualizados = (poly) => {
        const path = poly.getPath();
        const coords = [];
        for (let i = 0; i < path.getLength(); i++) {
            coords.push({
                lat: path.getAt(i).lat(),
                lng: path.getAt(i).lng()
            });
        }
        setPuntos(coords);
    };

    const handleMapClick = (event) => {
        const nuevaCoord = { lat: event.latLng.lat(), lng: event.latLng.lng() };
        setPuntos((prev) => {
            const nuevaLista = [...prev, nuevaCoord];
            actualizarVisuales(nuevaLista);
            return nuevaLista;
        });
    };

    const deshacerUltimo = () => {
        const nuevaLista = puntos.slice(0, -1);
        setPuntos(nuevaLista);
        actualizarVisuales(nuevaLista);
    };

    const limpiarMapa = () => {
        setPuntos([]);
        setOverlays([]);
        polygonRef.current = null;
    };

    const handleSave = () => {
        const valNombre = nombre; // refNombre.current?.value || '';

        if (!valNombre.trim()) {
            toast.current.show({
                severity: 'warn',
                summary: 'Atención',
                detail: 'Debe Llenar Nombre de la zona'
            });
            return;
        }

        if (puntos.length < 3) {
            toast.current.show({
                severity: 'warn',
                summary: 'Atención',
                detail: 'Una cerca válida requiere al menos 3 puntos.'
            });
            return;
        }

        // Formatear para base de datos (Cerramos el polígono repitiendo el primer punto)
        const puntosCerrados = [...puntos, puntos[0]];
        const puntosString = puntosCerrados.map((p) => `${p.lat} ${p.lng}`).join(', ');

        const objReturn = {
            nombre: valNombre,
            geocerca: `POLYGON ((${puntosString}))`,
            rawPuntos: JSON.stringify(puntos) // Útil si necesitas recargar el componente después
        };

        onConfirmar(objReturn);
    };

    useEffect(() => {
        const inicial = () => {
            if (datZona?.ubicacionId) {
                //setInputValue(refNombre, datZona?.nombre);
                setNombre(datZona?.nombre);
            }
        };
        inicial();
    }, [datZona?.codigo, datZona?.nombre, datZona?.ubicacionId]);

    if (!mapReady) return <div className="p-5 text-center">Cargando Mapa de Cerca...</div>;

    const limpiarBusqueda = () => {
        setSearchQuery(''); // Limpia el texto del input

        setOverlays((prev) => {
            // Filtramos: solo dejamos lo que NO sea un Marker
            // (Esto mantiene tu Polígono intacto)
            return prev.filter((ov) => !(ov instanceof window.google.maps.Marker));
        });
    };

    return (
        <div className="flex flex-column gap-3">
            <Toast ref={toast} />

            <div className="formgrid grid p-fluid mb-3">
                {soloConsulta ? (
                    <span>Nada</span>
                ) : (
                    <>
                        <div className="field col-12 md:col-8">
                            <label className="font-bold">Nombre de la Geocerca:</label>
                            <InputText
                                value={nombre}
                                defaultValue=""
                                onChange={(e) => setNombre(e.target.value)}
                                onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
                                maxLength={100}
                            />
                        </div>
                        <div className="field col-12 md:col-4">
                            <label style={{ visibility: 'hidden' }}>Texto oculto</label>
                        </div>
                    </>
                )}
                <div className="field col-12 md:col-12">
                    {/* Búsqueda */}
                    <div className="p-inputgroup flex-1">
                        <span className="p-inputgroup-addon">
                            <i className="pi pi-search"></i>
                        </span>
                        <InputText
                            ref={inputSearchRef}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            placeholder="Busca una dirección..."
                            className="p-inputtext-sm"
                        />
                        <Button
                            type="button"
                            icon="pi pi-times"
                            className="p-button-danger p-button-outlined"
                            onClick={limpiarBusqueda}
                        />
                    </div>
                    {/* Búsqueda*/}
                </div>

                <div className="field col-12 md:col-12">
                    <div className="surface-border border-2 border-round p-1 shadow-2">
                        <GMap
                            key={`${currentCenter.lat}-${currentCenter.lng}`}
                            options={{
                                center: currentCenter,
                                zoom: 15,
                                mapTypeId: 'roadmap'
                            }}
                            overlays={overlays}
                            style={{ width: '100%', height: '450px' }}
                            onMapClick={handleMapClick}
                            onViewportChange={(e) => {
                                setCurrentCenter({
                                    lat: e.map.getCenter().lat(),
                                    lng: e.map.getCenter().lng()
                                });
                            }}
                        />
                    </div>
                </div>
                {soloConsulta ? (
                    <span>Nada</span>
                ) : (
                    <>
                        <div className="field col-12 md:col-12">
                            <div className="flex justify-content-between align-items-center">
                                <div className="flex gap-2">
                                    <Button
                                        label="Deshacer"
                                        icon="pi pi-undo"
                                        className="p-button-secondary p-button-outlined"
                                        onClick={deshacerUltimo}
                                        disabled={puntos.length === 0}
                                    />
                                    <Button
                                        label="Limpiar Todo"
                                        icon="pi pi-trash"
                                        className="p-button-danger p-button-outlined"
                                        onClick={limpiarMapa}
                                        disabled={puntos.length === 0}
                                    />
                                </div>

                                <div className="flex gap-2">
                                    <Button
                                        label="Cancelar"
                                        className="p-button-text p-button-plain"
                                        onClick={onCancelar}
                                    />
                                    <Button
                                        label="Guardar Geocerca"
                                        icon="pi pi-save"
                                        className="p-button-primary"
                                        onClick={handleSave}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                )}

                <div className="field col-12 md:col-12">
                    <small className="text-500">
                        * Haz clic para crear los vértices. <b>Tip:</b> Puedes arrastrar los puntos blancos para ajustar
                        el área o mover toda la cerca.
                    </small>
                </div>
            </div>
        </div>
    );
};

export default DibujadorDeCerca;
